export default __webpack_public_path__ + "static/media/box.88facffe.svg";